/*import http from "../../services/api";

export default async function checkout(cart:any[]) {
  await http.post("/sales", {
    items: cart.map(i => ({
      product_id: i.product_id,
      quantity: i.quantity,
      price: i.price
    }))
  });
}
*/
//C:\xampp\htdocs\pms2\frontend\src\components\sales\Checkout.tsx
/*
import api from "../../services/api";

export default async function checkout(cart: any[]) {
  if (!cart.length) return;

  try {
    await api.post("/sales", {
      items: cart.map(i => ({
        product_id: i.product_id,
        quantity: i.quantity,
        price: i.price
      })),
      payment_method: "cash" // ✅ must send this, or make it dynamic
    });

    alert("Sale completed successfully ✅");
  } catch (err: any) {
    if (err.response?.status === 401) {
      alert("Please login as cashier to checkout.");
    } else {
      alert("Checkout failed. Try again.");
    }
    throw err;
  }
}
*/
/*
import React, { useState } from "react";
import api from "../../services/api";
import { SaleItem } from "../../types/sale";
import { toast } from "react-toastify";

interface CheckoutProps {
  cart: SaleItem[];
  setCart: React.Dispatch<React.SetStateAction<SaleItem[]>>;
}

const banks = [
  { value: "cbe", label: "Commercial Bank of Ethiopia" },
  { value: "dashen", label: "Dashen Bank" },
  { value: "awash", label: "Awash Bank" },
  { value: "abyssinia", label: "Bank of Abyssinia" },
  { value: "coop", label: "Cooperative Bank of Oromia" },
];

export default function Checkout({ cart, setCart }: CheckoutProps) {
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [selectedBank, setSelectedBank] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const total = cart.reduce((sum, i) => sum + i.price * i.quantity, 0);

  const handleCheckout = async () => {
    if (!cart.length) {
      toast.error("Cart is empty");
      return;
    }

    setLoading(true);
    try {
      const payload: any = {
        items: cart.map((i) => ({
          product_id: i.product_id,
          quantity: i.quantity,
          price: i.price,
        })),
        payment_method: paymentMethod,
      };

      if (paymentMethod === "mobile_money" && selectedBank) {
        payload.bank = selectedBank; // ✅ include bank
      }

      const res = await api.post("/sales/pay", payload);

      const { redirect_url } = res.data;
      if (redirect_url) {
        window.location.href = redirect_url; // ✅ redirect to gateway
      } else {
        toast.success("Sale recorded successfully ✅");
        setCart([]);
      }
    } catch (err: any) {
      toast.error("Checkout failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card p-4 shadow-sm">
      <h4 className="fw-bold mb-3">Checkout</h4>

      <div className="mb-3">
        <label className="form-label fw-semibold">Payment Method</label>
        <select
          className="form-select"
          value={paymentMethod}
          onChange={(e) => {
            setPaymentMethod(e.target.value);
            setSelectedBank(null); // reset bank if switching method
          }}
        >
          <option value="cash">💵 Cash</option>
          <option value="mobile_money">📱 Mobile Banking</option>
          <option value="telebirr">🌐 Telebirr</option>
        </select>
      </div>

      {paymentMethod === "mobile_money" && (
        <div className="mb-3">
          <label className="form-label fw-semibold">Select Bank</label>
          <select
            className="form-select"
            value={selectedBank || ""}
            onChange={(e) => setSelectedBank(e.target.value)}
          >
            <option value="">-- Choose Bank --</option>
            {banks.map((bank) => (
              <option key={bank.value} value={bank.value}>
                {bank.label}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="d-flex justify-content-between align-items-center mt-3">
        <strong>Total: {total} ETB</strong>
        <button
          className="btn btn-success btn-lg"
          onClick={handleCheckout}
          disabled={loading}
        >
          {loading ? "Processing..." : "Checkout"}
        </button>
      </div>
    </div>
  );
}
*/
/*
import React, { useState } from "react";
import { SaleItem } from "../../types/sale";
import { useCheckout } from "../../hooks/useCheckout";

interface CheckoutProps {
  cart: SaleItem[];
  setCart: React.Dispatch<React.SetStateAction<SaleItem[]>>;
}

const banks = [
  { value: "cbe", label: "Commercial Bank of Ethiopia" },
  { value: "dashen", label: "Dashen Bank" },
  { value: "awash", label: "Awash Bank" },
  { value: "abyssinia", label: "Bank of Abyssinia" },
  { value: "coop", label: "Cooperative Bank of Oromia" },
];

export default function Checkout({ cart, setCart }: CheckoutProps) {
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [selectedBank, setSelectedBank] = useState<string | null>(null);
  const { checkout, loading, lastSale } = useCheckout();

  const total = cart.reduce((sum, i) => sum + i.price * i.quantity, 0);

  const handleCheckout = async () => {
    const saleResponse = await checkout(cart, { paymentMethod, bank: selectedBank });
    if (saleResponse) {
      setCart([]);
    }
  };

  return (
    <div className="card p-4 shadow-sm">
      <h4 className="fw-bold mb-3">Checkout</h4>

      <div className="mb-3">
        <label className="form-label fw-semibold">Payment Method</label>
        <select
          className="form-select"
          value={paymentMethod}
          onChange={(e) => {
            setPaymentMethod(e.target.value);
            setSelectedBank(null);
          }}
        >
          <option value="cash">💵 Cash</option>
          <option value="mobile_money">📱 Mobile Banking</option>
          <option value="telebirr">🌐 Telebirr</option>
        </select>
      </div>

      {paymentMethod === "mobile_money" && (
        <div className="mb-3">
          <label className="form-label fw-semibold">Select Bank</label>
          <select
            className="form-select"
            value={selectedBank || ""}
            onChange={(e) => setSelectedBank(e.target.value)}
          >
            <option value="">-- Choose Bank --</option>
            {banks.map((bank) => (
              <option key={bank.value} value={bank.value}>
                {bank.label}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="d-flex justify-content-between align-items-center mt-3">
        <strong>Total: {total} ETB</strong>
        <button
          className="btn btn-success btn-lg"
          onClick={handleCheckout}
          disabled={loading}
        >
          {loading ? "Processing..." : "Checkout"}
        </button>
      </div>

      {lastSale && (
        <div className="alert alert-info mt-3">
          <h5>Sale Confirmation</h5>
          <p>Status: {lastSale.sale.status}</p>
          <p>Total Amount: {lastSale.sale.total_amount} ETB</p>
          <ul>
            {lastSale.sale.items.map((item) => (
              <li key={item.id}>
                {item.product?.name || "Product"} × {item.quantity} @ {item.price} ETB
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

*/
/*
import React, { useState } from "react";
import { SaleItem } from "../../types/sale";
import { checkoutRequest } from "../../services/checkoutService";
import { isValidEthiopianPhone, isValidName } from "../../utils/validators";
import { log } from "../../utils/logger";

const banks = [
  { value: "cbe", label: "Commercial Bank of Ethiopia" },
  { value: "dashen", label: "Dashen Bank" },
  { value: "awash", label: "Awash Bank" },
  { value: "abyssinia", label: "Bank of Abyssinia" },
  { value: "coop", label: "Cooperative Bank of Oromia" },
];

interface Props {
  cart: SaleItem[];
  setCart: React.Dispatch<React.SetStateAction<SaleItem[]>>;
}

export default function Checkout({ cart, setCart }: Props) {
  const [customerName, setCustomerName] = useState("");
  const [phone, setPhone] = useState("");
  const [paymentMethod, setPaymentMethod] =
    useState<"cash" | "telebirr" | "mobile_banking">("cash");
  const [bank, setBank] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [invoice, setInvoice] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  const total = cart.reduce((s, i) => s + i.price * i.quantity, 0);

  async function handleCheckout() {
    setError(null);

    if (!isValidName(customerName)) {
      setError("Please enter your full name.");
      return;
    }

    if (!isValidEthiopianPhone(phone)) {
      setError("Invalid Ethiopian phone number.");
      return;
    }

    if (paymentMethod === "mobile_banking" && !bank) {
      setError("Please select a bank.");
      return;
    }

    try {
      setLoading(true);

      const data = await checkoutRequest({
        customer_name: customerName,
        phone,
        items: cart,
        payment_method: paymentMethod,
        bank,
      });

      log.info("Checkout successful", data);

      setInvoice(data);
      setCart([]);

    } catch (err: any) {
      log.error("Checkout failed", err);
      setError("Checkout failed. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="card p-4 shadow-sm">
      <h4 className="fw-bold mb-3">Checkout</h4>

      {error && <div className="alert alert-danger">{error}</div>}

      {/* Customer Info /}
      <div className="mb-3">
        <label className="form-label">Full Name</label>
        <input
          className="form-control"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
          placeholder="First Middle Last"
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Phone Number</label>
        <input
          className="form-control"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="+2519XXXXXXXX or 09XXXXXXXX"
        />
      </div>

      {/* Payment Method /}
      <div className="mb-3">
        <label className="form-label">Payment Method</label>
        <select
          className="form-select"
          value={paymentMethod}
          onChange={(e) => {
            setPaymentMethod(e.target.value as any);
            setBank(null);
          }}
        >
          <option value="cash">💵 Cash</option>
          <option value="telebirr">🌐 Telebirr</option>
          <option value="mobile_banking">📱 Mobile Banking</option>
        </select>
      </div>

      {paymentMethod === "mobile_banking" && (
        <div className="mb-3">
          <label className="form-label">Select Bank</label>
          <select
            className="form-select"
            value={bank ?? ""}
            onChange={(e) => setBank(e.target.value)}
          >
            <option value="">-- Choose Bank --</option>
            {banks.map((b) => (
              <option key={b.value} value={b.value}>
                {b.label}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="d-flex justify-content-between align-items-center">
        <strong>Total: {total} ETB</strong>
        <button
          className="btn btn-success btn-lg"
          disabled={loading}
          onClick={handleCheckout}
        >
          {loading ? "Processing..." : "Confirm Checkout"}
        </button>
      </div>

      {/* Invoice Display /}
      {invoice && (
        <div className="alert alert-info mt-4">
          <h5>Invoice Generated</h5>
          <p><strong>Invoice:</strong> {invoice.invoice}</p>
          <p><strong>Amount:</strong> {invoice.amount} ETB</p>
          {invoice.reference && (
            <p><strong>Payment Reference:</strong> {invoice.reference}</p>
          )}
          <p className="text-muted">
            This invoice is not a receipt until payment is confirmed.
          </p>
        </div>
      )}
    </div>
  );
}

*/
/*
import React, { useState } from "react";
import { SaleItem } from "../../types/sale";
import { SaleResponse } from "../../types/checkout";
import { checkoutRequest } from "../../services/checkoutService";
import { isValidEthiopianPhone, isValidName } from "../../utils/validators";
import { log } from "../../utils/logger";

const banks = [
  { value: "cbe", label: "Commercial Bank of Ethiopia" },
  { value: "dashen", label: "Dashen Bank" },
  { value: "awash", label: "Awash Bank" },
  { value: "abyssinia", label: "Bank of Abyssinia" },
  { value: "coop", label: "Cooperative Bank of Oromia" },
];

interface Props {
  cart: SaleItem[];
  setCart: React.Dispatch<React.SetStateAction<SaleItem[]>>;
}

type UiError =
  | { type: "validation"; message: string }
  | { type: "backend"; message: string; status?: number }
  | { type: "network"; message: string };

export default function Checkout({ cart, setCart }: Props) {
  const [customerName, setCustomerName] = useState("");
  const [phone, setPhone] = useState("");
  const [paymentMethod, setPaymentMethod] =
    useState<"cash" | "telebirr" | "mobile_banking">("cash");
  const [bank, setBank] = useState<string | null>(null);

  const [loading, setLoading] = useState(false);
  const [invoice, setInvoice] = useState<SaleResponse | null>(null);
  const [error, setError] = useState<UiError | null>(null);

  const total = cart.reduce((s, i) => s + i.price * i.quantity, 0);

  async function handleCheckout() {
    setError(null);

    /* ---------- FRONTEND VALIDATION ---------- /
    if (!isValidName(customerName)) {
      setError({ type: "validation", message: "Please enter your full name." });
      return;
    }

    if (!isValidEthiopianPhone(phone)) {
      setError({
        type: "validation",
        message: "Invalid Ethiopian phone number.",
      });
      return;
    }

    if (paymentMethod === "mobile_banking" && !bank) {
      setError({
        type: "validation",
        message: "Please select a bank.",
      });
      return;
    }

    /* ---------- API CALL ---------- /
    try {
      setLoading(true);

      log.info("Checkout request started", {
        customerName,
        phone,
        paymentMethod,
        bank,
        cartSize: cart.length,
      });

      const response: SaleResponse = await checkoutRequest({
        customer_name: customerName,
        phone,
        items: cart,
        payment_method: paymentMethod,
        bank,
      });

      /* ---------- BACKEND CONTRACT CHECK ---------- /
      if (!response.success || !response.reference) {
        log.error("Backend contract violation", response);
        setError({
          type: "backend",
          message: "Invalid response from server.",
        });
        return;
      }

      log.info("Checkout successful", response);

      setInvoice(response);
      setCart([]);

    } catch (err: any) {
      /* ---------- ERROR CLASSIFICATION ---------- /

      if (!err.response) {
        // Network / CORS / server down
        log.error("Network error", err);
        setError({
          type: "network",
          message: "Cannot reach server. Check connection.",
        });
      } else {
        // Backend returned an error
        log.error("Backend error", {
          status: err.response.status,
          data: err.response.data,
        });

        setError({
          type: "backend",
          status: err.response.status,
          message:
            err.response.data?.message ||
            "Checkout failed due to server error.",
        });
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="card p-4 shadow-sm">
      <h4 className="fw-bold mb-3">Checkout</h4>

      {/* ---------- ERROR DISPLAY ---------- /}
      {error && (
        <div className="alert alert-danger">
          <strong>
            {error.type === "validation" && "Input Error"}
            {error.type === "backend" && "Server Error"}
            {error.type === "network" && "Network Error"}
          </strong>
          <div>{error.message}</div>
          {error.type === "backend" && error.status && (
            <small className="text-muted">
              HTTP {error.status}
            </small>
          )}
        </div>
      )}

      {/* ---------- CUSTOMER INFO ---------- /}
      <div className="mb-3">
        <label className="form-label">Full Name</label>
        <input
          className="form-control"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
          placeholder="First Middle Last"
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Phone Number</label>
        <input
          className="form-control"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="+2519XXXXXXXX or 09XXXXXXXX"
        />
      </div>

      {/* ---------- PAYMENT METHOD ---------- /}
      <div className="mb-3">
        <label className="form-label">Payment Method</label>
        <select
          className="form-select"
          value={paymentMethod}
          onChange={(e) => {
            setPaymentMethod(e.target.value as any);
            setBank(null);
          }}
        >
          <option value="cash">💵 Cash</option>
          <option value="telebirr">🌐 Telebirr</option>
          <option value="mobile_banking">📱 Mobile Banking</option>
        </select>
      </div>

      {paymentMethod === "mobile_banking" && (
        <div className="mb-3">
          <label className="form-label">Select Bank</label>
          <select
            className="form-select"
            value={bank ?? ""}
            onChange={(e) => setBank(e.target.value)}
          >
            <option value="">-- Choose Bank --</option>
            {banks.map((b) => (
              <option key={b.value} value={b.value}>
                {b.label}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="d-flex justify-content-between align-items-center">
        <strong>Total: {total} ETB</strong>
        <button
          className="btn btn-success btn-lg"
          disabled={loading || cart.length === 0}
          onClick={handleCheckout}
        >
          {loading ? "Processing..." : "Confirm Checkout"}
        </button>
      </div>

      {/* ---------- INVOICE ---------- /}
      {invoice && (
        <div className="alert alert-info mt-4">
          <h5>Invoice Created</h5>
          <p><strong>Reference:</strong> {invoice.reference}</p>
          <p><strong>Amount:</strong> {invoice.amount} ETB</p>
          <p><strong>Payment Method:</strong> {invoice.payment_method}</p>
          <p className="text-muted">
            This is not a receipt until payment is confirmed.
          </p>
        </div>
      )}
    </div>
  );
}
*/
/*
import React, { useState } from "react";
import { SaleItem } from "../../types/sale";
import { CheckoutResponse, PaymentMethod } from "../../types/checkout";
import { isValidEthiopianPhone, isValidName } from "../../utils/validators";
import { log } from "../../utils/logger";
import { useCheckout } from "../../hooks/useCheckout";


const banks = [
  { value: "cbe", label: "Commercial Bank of Ethiopia" },
  { value: "dashen", label: "Dashen Bank" },
  { value: "awash", label: "Awash Bank" },
  { value: "abyssinia", label: "Bank of Abyssinia" },
  { value: "coop", label: "Cooperative Bank of Oromia" },
];

interface Props {
  cart: SaleItem[];
  setCart: React.Dispatch<React.SetStateAction<SaleItem[]>>;
}

type UiError =
  | { type: "validation"; message: string }
  | { type: "backend"; message: string; status?: number }
  | { type: "network"; message: string };

export default function Checkout({ cart, setCart }: Props) {
  const [customerName, setCustomerName] = useState("");
const [phone, setPhone] = useState("");

const [paymentMethod, setPaymentMethod] =
  useState<PaymentMethod>("cash");

const [bank, setBank] = useState<string | null>(null);

const [invoice, setInvoice] =
  useState<CheckoutResponse | null>(null);

/* 🔴 THIS FIXES ALL setError / error ISSUES /
const [error, setError] = useState<UiError | null>(null);


  const { checkout, loading } = useCheckout();

  const total = cart.reduce((s, i) => s + i.price * i.quantity, 0);

  async function handleCheckout() {
    setError(null);

    /* ---------- FRONTEND VALIDATION ---------- /
    if (!isValidName(customerName)) {
      setError({ type: "validation", message: "Please enter your full name." });
      return;
    }

    if (!isValidEthiopianPhone(phone)) {
      setError({
        type: "validation",
        message: "Invalid Ethiopian phone number.",
      });
      return;
    }

    if (paymentMethod === "mobile_banking" && !bank) {
      setError({
        type: "validation",
        message: "Please select a bank.",
      });
      return;
    }

    /* ---------- API CALL ---------- /
    try {
      log.info("Checkout request started", {
        customerName,
        phone,
        paymentMethod,
        bank,
        cartSize: cart.length,
      });

      const response = await checkout(
  customerName,
  phone,
  paymentMethod,
  bank,
  cart
);

if (!response) {
  setError({
    type: "backend",
    message: "Checkout failed. Please retry.",
  });
  return;
}

setInvoice(response);
setCart([]);



      log.info("Checkout successful", response);

      setInvoice(response);
      setCart([]);

    } catch (err: any) {
      /* ---------- ERROR CLASSIFICATION ---------- /
      if (!err.response) {
        // Network / CORS / server down
        log.error("Network error", err);
        setError({
          type: "network",
          message: "Cannot reach server. Check connection.",
        });
      } else {
        // Backend returned an error
        log.error("Backend error", {
          status: err.response.status,
          data: err.response.data,
        });

        setError({
          type: "backend",
          status: err.response.status,
          message:
            err.response.data?.message ||
            "Checkout failed due to server error.",
        });
      }
    }
  }

  return (
    <div className="card p-4 shadow-sm">
      <h4 className="fw-bold mb-3">Checkout</h4>

      {/* ---------- ERROR DISPLAY ---------- /}
      {error && (
        <div className="alert alert-danger">
          <strong>
            {error.type === "validation" && "Input Error"}
            {error.type === "backend" && "Server Error"}
            {error.type === "network" && "Network Error"}
          </strong>
          <div>{error.message}</div>
          {error.type === "backend" && error.status && (
            <small className="text-muted">HTTP {error.status}</small>
          )}
        </div>
      )}

      {/* ---------- CUSTOMER INFO ---------- /}
      <div className="mb-3">
        <label className="form-label">Full Name</label>
        <input
          className="form-control"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
          placeholder="First Middle Last"
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Phone Number</label>
        <input
          className="form-control"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="+2519XXXXXXXX or 09XXXXXXXX"
        />
      </div>

      {/* ---------- PAYMENT METHOD ---------- /}
            <div className="mb-3">
        <label className="form-label">Payment Method</label>
        <select
          className="form-select"
          value={paymentMethod}
          onChange={(e) => {
            setPaymentMethod(e.target.value as any);
            setBank(null);
          }}
        >
          <option value="cash">💵 Cash</option>
          <option value="telebirr">🌐 Telebirr</option>
          <option value="mobile_banking">📱 Mobile Banking</option>
        </select>
      </div>

      {paymentMethod === "mobile_banking" && (
        <div className="mb-3">
          <label className="form-label">Select Bank</label>
          <select
            className="form-select"
            value={bank ?? ""}
            onChange={(e) => setBank(e.target.value)}
          >
            <option value="">-- Choose Bank --</option>
            {banks.map((b) => (
              <option key={b.value} value={b.value}>
                {b.label}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="d-flex justify-content-between align-items-center">
        <strong>Total: {total} ETB</strong>
        <button type="button"
          className="btn btn-success btn-lg"
          disabled={loading || cart.length === 0}
          onClick={handleCheckout}
        >
          {loading ? "Processing..." : "Confirm Checkout"}
        </button>
      </div>

      {/* ---------- INVOICE ---------- /}
      {invoice && (
        <div className="alert alert-info mt-4">
          <h5>Invoice Created</h5>
          <p><strong>Reference:</strong> {invoice.reference}</p>
          <p><strong>Amount:</strong> {invoice.amount} ETB</p>
          <p><strong>Payment Method:</strong> {invoice.payment_method}</p>
          <p className="text-muted">
            This is not a receipt until payment is confirmed.
          </p>
        </div>
      )}
    </div>
  );
}
*/
//C:\xampp\htdocs\pms2\frontend\src\components\sales\Checkout.tsx
/*
import React, { useEffect, useMemo, useState } from "react";
import { SaleItem } from "../../types/sale";
import { CheckoutResponse, PaymentMethod } from "../../types/checkout";
import { isValidEthiopianPhone, isValidName } from "../../utils/validators";
import { log } from "../../utils/logger";
import { useCheckout } from "../../hooks/useCheckout";
import { usePaymentStatus } from "../../hooks/usePaymentStatus";

/* -------------------- Constants --------------------/

const BANKS = [
  { value: "cbe", label: "Commercial Bank of Ethiopia" },
  { value: "dashen", label: "Dashen Bank" },
  { value: "awash", label: "Awash Bank" },
  { value: "abyssinia", label: "Bank of Abyssinia" },
  { value: "coop", label: "Cooperative Bank of Oromia" },
] as const;

/* -------------------- Types -------------------- /

interface Props {
  cart: SaleItem[];
  setCart: React.Dispatch<React.SetStateAction<SaleItem[]>>;
}

type UiError =
  | { type: "validation"; message: string }
  | { type: "network"; message: string }
  | { type: "backend"; message: string; status?: number };

/* -------------------- Component -------------------- /

export default function Checkout({ cart, setCart }: Props) {
  /* ---------- Form State ---------- /
  const [customerName, setCustomerName] = useState("");
  const [phone, setPhone] = useState("");
  const [paymentMethod, setPaymentMethod] =
    useState<PaymentMethod>("cash");
  const [bank, setBank] = useState<string | null>(null);

  /* ---------- Result State ---------- /
  const [invoice, setInvoice] = useState<CheckoutResponse | null>(null);
  const [saleId, setSaleId] = useState<number | null>(null);

  /* ---------- Error State ---------- /
  const [error, setError] = useState<UiError | null>(null);

  /* ---------- Hooks ---------- /
  const { checkout, loading } = useCheckout();
  const paymentStatus = usePaymentStatus(saleId);
const [timeLeft, setTimeLeft] = useState<number | null>(null);

  /* ---------- Derived ---------- /
  const total = useMemo(
    () => cart.reduce((sum, i) => sum + i.price * i.quantity, 0),
    [cart]
  );

  /* ---------- Effects ---------- /

  // Clear cart only AFTER checkout is created
  useEffect(() => {
  if (invoice && invoice.id && invoice.status === "pending") {
    setCart([]);
  }
}, [invoice]);


useEffect(() => {
  if (!invoice?.payment_intent?.expires_at) return;

  const interval = setInterval(() => {
    const expiry = new Date(invoice.payment_intent!.expires_at).getTime();
    const diff = expiry - Date.now();

    setTimeLeft(Math.max(diff, 0));

    if (diff <= 0) clearInterval(interval);
  }, 1000);

  return () => clearInterval(interval);
}, [invoice]);


  /* -------------------- Handlers -------------------- /

  async function handleCheckout() {
    setError(null);

    /* ---------- Frontend Validation ---------- /
    if (!isValidName(customerName)) {
      setError({
        type: "validation",
        message: "Please enter your full legal name (First Middle Last).",
      });
      return;
    }

    if (!isValidEthiopianPhone(phone)) {
      setError({
        type: "validation",
        message: "Invalid Ethiopian phone number format.",
      });
      return;
    }

    if (paymentMethod === "mobile_banking" && !bank) {
      setError({
        type: "validation",
        message: "Please select a bank.",
      });
      return;
    }

    if (cart.length === 0) {
      setError({
        type: "validation",
        message: "Your cart is empty.",
      });
      return;
    }

    /* ---------- Checkout Call ---------- /
    try {
      log.info("checkout.started", {
        customerName,
        phone,
        paymentMethod,
        bank,
        items: cart.length,
      });

      const response = await checkout(
        customerName,
        phone,
        paymentMethod,
        bank,
        cart
      );

      if (!response) {
        throw new Error("Checkout returned null");
      }

      setInvoice(response);
      setSaleId(response.id);

      log.info("checkout.created", response);
    } catch (err: any) {
      log.error("checkout.failed", err);

      if (!err.response) {
        setError({
          type: "network",
          message: "Cannot reach server. Please check your connection.",
        });
        return;
      }

      setError({
        type: "backend",
        status: err.response.status,
        message:
          err.response.data?.message ??
          "Checkout failed due to a server error.",
      });
    }
  }

  /* -------------------- Render -------------------- /

  return (
    <div className="card p-4 shadow-sm">
      <h4 className="fw-bold mb-3">Checkout</h4>

      {/* ---------- Errors ---------- /}
      {error && (
        <div className="alert alert-danger">
          <strong>
            {error.type === "validation" && "Input Error"}
            {error.type === "network" && "Network Error"}
            {error.type === "backend" && "Server Error"}
          </strong>
          <div>{error.message}</div>
          {error.type === "backend" && error.status && (
            <small className="text-muted">HTTP {error.status}</small>
          )}
        </div>
      )}

      {/* ---------- Customer Info ---------- /}
      <div className="mb-3">
        <label className="form-label">Full Name</label>
        <input
          className="form-control"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
          placeholder="First Middle Last"
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Phone Number</label>
        <input
          className="form-control"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="+2519XXXXXXXX or 09XXXXXXXX"
        />
      </div>

      {/* ---------- Payment Method ---------- /}
      <div className="mb-3">
        <label className="form-label">Payment Method</label>
        <select
          className="form-select"
          value={paymentMethod}
          onChange={(e) => {
            setPaymentMethod(e.target.value as PaymentMethod);
            setBank(null);
          }}
        >
          <option value="cash">💵 Cash</option>
          <option value="telebirr">🌐 Telebirr</option>
          <option value="mobile_banking">📱 Mobile Banking</option>
        </select>
      </div>

      {paymentMethod === "mobile_banking" && (
        <div className="mb-3">
          <label className="form-label">Select Bank</label>
          <select
            className="form-select"
            value={bank ?? ""}
            onChange={(e) => setBank(e.target.value)}
          >
            <option value="">-- Choose Bank --</option>
            {BANKS.map((b) => (
              <option key={b.value} value={b.value}>
                {b.label}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* ---------- Submit ---------- /}
      <div className="d-flex justify-content-between align-items-center">
        <strong>Total: {total} ETB</strong>
        <button
          type="button"
          className="btn btn-success btn-lg"
          disabled={loading || cart.length === 0}
          onClick={handleCheckout}
        >
          {loading ? "Processing..." : "Confirm Checkout"}
        </button>
      </div>

      {/* ---------- Invoice ---------- /}
      {invoice && (
  <div className="alert alert-info mt-4">
    <h5>Invoice Generated</h5>
    <p><strong>Invoice Number:</strong> {invoice.invoice_number}</p>
    <p><strong>Total Amount:</strong> {invoice.total_amount} ETB</p>
    <p><strong>Payment Method:</strong> {invoice.payment_method}</p>

    {invoice.payment_intent && (
  <>
    <p><strong>Payment Code:</strong> {invoice.payment_intent.reference_code}</p>
    <p><strong>Expires At:</strong> {invoice.payment_intent.expires_at}</p>
  </>
)}


    {paymentStatus === "pending" && (
      <p className="text-warning">Waiting for payment confirmation…</p>
    )}
    {paymentStatus === "paid" && (
      <p className="text-success">Payment confirmed. Receipt issued.</p>
    )}
    {paymentStatus === "failed" && (
      <p className="text-danger">Payment failed. Please retry.</p>
    )}
    {paymentStatus === "expired" && (
  <p className="text-danger">
    Payment expired. Please create a new checkout.
  </p>
)}


    <p className="text-muted">
      This invoice is not a receipt until payment is confirmed.
    </p>
  </div>
)}
    </div>
  );
}

*/

import React, { useEffect, useMemo, useState } from "react";
import { SaleItem } from "../../types/sale";
import { CheckoutResponse, PaymentMethod } from "../../types/checkout";
import { isValidEthiopianPhone, isValidName } from "../../utils/validators";
import { log } from "../../utils/logger";
import { useCheckout } from "../../hooks/useCheckout";
import { usePaymentStatus } from "../../hooks/usePaymentStatus";

const BANKS = [
  { value: "cbe", label: "Commercial Bank of Ethiopia" },
  { value: "dashen", label: "Dashen Bank" },
  { value: "awash", label: "Awash Bank" },
  { value: "abyssinia", label: "Bank of Abyssinia" },
  { value: "coop", label: "Cooperative Bank of Oromia" },
] as const;

interface Props {
  cart: SaleItem[];
  setCart: React.Dispatch<React.SetStateAction<SaleItem[]>>;
}

type UiError =
  | { type: "validation"; message: string }
  | { type: "network"; message: string }
  | { type: "backend"; message: string; status?: number };

export default function Checkout({ cart, setCart }: Props) {
  const [customerName, setCustomerName] = useState("");
  const [phone, setPhone] = useState("");
  const [paymentMethod, setPaymentMethod] =
    useState<PaymentMethod>("cash");
  const [bank, setBank] = useState<string | null>(null);

  const [invoice, setInvoice] = useState<CheckoutResponse | null>(null);
  const [saleId, setSaleId] = useState<number | null>(null);
  const [error, setError] = useState<UiError | null>(null);
  const [timeLeft, setTimeLeft] = useState<number | null>(null);

  const { checkout, loading } = useCheckout();
  const paymentStatus = usePaymentStatus(saleId);

  const total = useMemo(
    () => cart.reduce((sum, i) => sum + i.price * i.quantity, 0),
    [cart]
  );

  useEffect(() => {
    if (invoice?.id) {
      setCart([]);
    }
  }, [invoice, setCart]);

  // Expiration Countdown
  useEffect(() => {
    if (!invoice?.payment_intent?.expires_at) return;

    const interval = setInterval(() => {
      const expiry = new Date(
        invoice.payment_intent!.expires_at
      ).getTime();

      const diff = expiry - Date.now();
      setTimeLeft(Math.max(diff, 0));

      if (diff <= 0) clearInterval(interval);
    }, 1000);

    return () => clearInterval(interval);
  }, [invoice]);

  async function handleCheckout() {
    setError(null);

    if (!isValidName(customerName)) {
      setError({
        type: "validation",
        message: "Please enter your full legal name.",
      });
      return;
    }

    if (!isValidEthiopianPhone(phone)) {
      setError({
        type: "validation",
        message: "Invalid Ethiopian phone number.",
      });
      return;
    }

    if (paymentMethod === "mobile_banking" && !bank) {
      setError({
        type: "validation",
        message: "Please select a bank.",
      });
      return;
    }

    if (cart.length === 0) {
      setError({
        type: "validation",
        message: "Your cart is empty.",
      });
      return;
    }

    try {
      const response = await checkout(
        customerName,
        phone,
        paymentMethod,
        bank,
        cart
      );

      setInvoice(response);
      setSaleId(response.id);

      log.info("checkout.created", response);
    } catch (err: any) {
      log.error("checkout.failed", err);

      if (!err.response) {
        setError({
          type: "network",
          message: "Cannot reach server.",
        });
      } else {
        setError({
          type: "backend",
          status: err.response.status,
          message:
            err.response.data?.message ??
            "Checkout failed due to server error.",
        });
      }
    }
  }

  return (
    <div className="card p-4 shadow-sm">
      <h4 className="fw-bold mb-3">Checkout</h4>

      {error && (
        <div className="alert alert-danger">
          <strong>
            {error.type === "validation" && "Input Error"}
            {error.type === "network" && "Network Error"}
            {error.type === "backend" && "Server Error"}
          </strong>
          <div>{error.message}</div>
          {error.type === "backend" && error.status && (
            <small className="text-muted">HTTP {error.status}</small>
          )}
        </div>
      )}

      <div className="mb-3">
        <label className="form-label">Full Name</label>
        <input
          className="form-control"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Phone Number</label>
        <input
          className="form-control"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Payment Method</label>
        <select
          className="form-select"
          value={paymentMethod}
          onChange={(e) => {
            setPaymentMethod(e.target.value as PaymentMethod);
            setBank(null);
          }}
        >
          <option value="cash">Cash</option>
          <option value="telebirr">Telebirr</option>
          <option value="mobile_banking">Mobile Banking</option>
        </select>
      </div>

      {paymentMethod === "mobile_banking" && (
        <div className="mb-3">
          <label className="form-label">Select Bank</label>
          <select
            className="form-select"
            value={bank ?? ""}
            onChange={(e) => setBank(e.target.value)}
          >
            <option value="">-- Choose Bank --</option>
            {BANKS.map((b) => (
              <option key={b.value} value={b.value}>
                {b.label}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="d-flex justify-content-between align-items-center">
        <strong>Total: {total} ETB</strong>
        <button
          type="button"
          className="btn btn-success btn-lg"
          disabled={loading || cart.length === 0 || !!invoice}
          onClick={handleCheckout}
        >
          {loading ? "Processing..." : "Confirm Checkout"}
        </button>
      </div>

      {invoice && (
        <div className="alert alert-info mt-4">
          <h5>Invoice Generated</h5>
          <p>
            <strong>Invoice:</strong> {invoice.invoice_number}
          </p>
          <p>
            <strong>Total:</strong> {invoice.total_amount} ETB
          </p>

          {invoice.payment_intent && (
            <>
              <p>
                <strong>Payment Code:</strong>{" "}
                {invoice.payment_intent.reference_code}
              </p>

              {timeLeft !== null && (
                <p className="text-muted">
                  Expires in: {Math.floor(timeLeft / 1000)} seconds
                </p>
              )}
            </>
          )}

          {paymentStatus === "pending" && (
            <p className="text-warning">
              Waiting for payment confirmation…
            </p>
          )}
          {paymentStatus === "paid" && (
            <p className="text-success">
              Payment confirmed. Receipt issued.
            </p>
          )}
          {paymentStatus === "failed" && (
            <p className="text-danger">Payment failed.</p>
          )}
          {paymentStatus === "expired" && (
            <p className="text-danger">
              Payment expired. Please create a new checkout.
            </p>
          )}
        </div>
      )}
    </div>
  );
}
